import { faEye, faEyeSlash, faUserLarge } from "@fortawesome/free-solid-svg-icons"
import React, { ChangeEvent, useState, useContext, useEffect } from "react"
import { IoSave } from 'react-icons/io5'
import { Icone } from "../../Components/Icones/Index"
import { Template } from "../../Components/Template/template"
import { LoginContext } from "../../Contexts/login-context"
import { NewUsuarios, TypePasswordProps, Usuarios, classInput, classLabel, AlertType, classInputDark, classLabelDark, classDivBody, classDivBackground, classBorderLabelDark, classBt, classbtAzulEscuro } from "../../Utils/Types"
import { FeedbackMessage } from '../../Components/FeedbackMessage/feedback-message'
import { v4 as uuid } from "uuid"

import { ProfileService } from "./profileService"
import { useDispatch } from 'react-redux'
import { changeHash, changeName } from "../../Components/Redux/userSlice"
import Logo4 from '../../assets/imagens/Logo4.png'


export const Profile = () => {

    const dispatch = useDispatch()

    const [usuario, setUsuario] = useState<Usuarios>()

    const getUsuarios = async () => {

        const usuario = await ProfileService.GetAttributes()

        setUsuario(usuario.data)
        setNome(usuario.data?.nome || '')
        setEmail(usuario.data.email || '')
    }

    useEffect(() => {
        getUsuarios()

    }, [])

    const [visible, setVisible] = useState(false)

    const { setLogo } = useContext(LoginContext)

    const [id, setId] = useState(0)
    const [loading, setLoading] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("SUCCESS")

    const [nome, setNome] = useState('')
    const [email, setEmail] = useState('')
    const [senha, setSenha] = useState('')
    const [novaSenha, setNovaSenha] = useState('')
    const [repetirSenha, setRepetirSenha] = useState('')

    const [showPassword, setShowPassword] = useState(false)
    const [showNewPassword, setShowNewPassword] = useState(false)
    const [showRepeatePassword, setShowRepeatePassword] = useState(false)
    const [passwordInputType, setPasswordInputType] = useState<TypePasswordProps>("password")
    const [newPasswordInputType, setNewPasswordInputType] = useState<TypePasswordProps>("password")
    const [repeatePasswordInputType, setRepeatePasswordInputType] = useState<TypePasswordProps>("password")

    const [urlLogo, setUrlLogo] = useState(localStorage.getItem('imageLogo') || Logo4)

    const handleChangeName = (e: ChangeEvent<HTMLInputElement>) => {
        setNome(e.target.value)
    }

    const handleChangeNewPassword = (e: ChangeEvent<HTMLInputElement>) => {
        setNovaSenha(e.target.value)
    }

    const handleChangeRepeatePassword = (e: ChangeEvent<HTMLInputElement>) => {
        setRepetirSenha(e.target.value)
    }

    const handleChangeEmail = (e: ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value)
    }

    const handleChangePassword = (e: ChangeEvent<HTMLInputElement>) => {
        setSenha(e.target.value)
    }

    const toggleShowPassword = () => {
        setShowPassword(!showPassword)
        setPasswordInputType(!showPassword ? 'text' : 'password')
    }

    const toggleShowNewPassword = () => {
        setShowNewPassword(!showNewPassword)
        setNewPasswordInputType(!showNewPassword ? 'text' : 'password')
    }

    const toggleShowRepeatePassword = () => {
        setShowRepeatePassword(!showRepeatePassword)
        setRepeatePasswordInputType(!showRepeatePassword ? 'text' : 'password')
    }

    const handleCloseMessage = () => {
        setVisible(false)
    }

    useEffect(() => {
        let hash = localStorage.getItem('@ecommerce/hash')
        let name = localStorage.getItem('@ecommerce/name')
        dispatch(changeHash(hash))
        dispatch(changeName(name))
    }, [])

    const handleToggleLogo = async () => {
        setLogo(uuid())

        let newUsuarios: NewUsuarios = {

            name: nome,
            oldPassword: senha,
            newPassword: novaSenha,
            repeatPassword: repetirSenha

        }

        setLoading(true)
        const resp = await ProfileService.Save(newUsuarios)
        setLoading(false)

        if (resp.error) {
            setVisible(true)
            setMessage(resp.msg || "")
            setMessageType("DANGER")

        } else {
            setId(resp.id || 0)
            setVisible(true)
            setMessage(resp.msg || "")
            setMessageType("SUCCESS")


            localStorage.setItem('@ecommerce/name', nome || '')

            dispatch(changeName(localStorage.getItem('@ecommerce/name')))

            const timer = setTimeout(() => {
                setVisible(false)
            }, 1500)

            return () => clearTimeout(timer)

        }


    }

    return (

        <Template>

            <div className={`${classDivBackground}`}>

                <div id="div-body" className={`${classDivBody}`}>
                    { /* Card */}
                    <div className="w-full h-auto bg-white border rounded-lg shadow-md dark:bg-slate-600 border-slate-300 dark:border-slate-800 shadow-indigo-200 dark:shadow-slate-800">

                        { /* Card Header */}
                        <div className="flex items-center w-full h-[80px] bg-white dark:bg-slate-600 rounded-lg   cursor-default">
                            <span className="ml-4 text-2xl dark:text-slate-200"> <Icone icon={faUserLarge} size="2x" cor="rgb(148 163 184)" /> Perfil do Usuário</span>
                        </div>
                        { /* Card Header */}

                        <hr className="w-full border border-slate-200 dark:border-slate-700" />

                        { /* Card Body */}
                        <div className="w-full h-[450px]">

                            <div className="flex flex-row w-full h-full">

                                <div className="flex items-center justify-center w-full h-full">

                                    <img className="w-[240px] h-[240px]" src={urlLogo || ''} alt="" />

                                </div>

                                <div className="grid w-full h-[50px] grid-cols-12 gap-3 px-5 mt-10">

                                    <div className='relative col-span-12'>
                                        <span className='text-[14px] text-[#ACACAC] dark:text-slate-300 '>Dados Pessoais</span>
                                    </div>

                                    <div className='relative col-span-12 mb-3'>
                                        <hr className="h-px border-0 bg-slate-300 dark:bg-slate-700" />
                                    </div>

                                    <div className="relative col-span-12 mb-3">
                                        <input type="text" id="nome_usuario" className={`${classInput} ${classInputDark}`} placeholder=" " value={nome} onChange={handleChangeName} />
                                        <label htmlFor="nome_usuario" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Nome do Usuário</label>
                                    </div>

                                    <div className="relative col-span-12 mb-3">
                                        <input disabled type="text" id="email_usuario" className={`${classInput} ${classInputDark} cursor-not-allowed`} placeholder=" " value={email} onChange={handleChangeEmail} />
                                        <label htmlFor="email_usuario" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} cursor-default`}>E-mail</label>
                                    </div>

                                    <div className="relative hidden col-span-12 mb-3">
                                        <input type={passwordInputType} id="senha_atual" className={`${classInput} ${classInputDark}`} placeholder=" " value={senha} onChange={handleChangePassword} />
                                        <label htmlFor="senha_atual" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Senha atual</label>

                                        <button onClick={toggleShowPassword} className="absolute right-0 mt-[8px] mr-[10px] justify-center text-slate-400 outline-none">
                                            <Icone icon={showPassword ? faEyeSlash : faEye} size="xl" />
                                        </button>
                                    </div>

                                    <div className="relative hidden col-span-12 mb-3">
                                        <input type={newPasswordInputType} id="nova_senha" className={`${classInput} ${classInputDark} `} placeholder=" " value={novaSenha} onChange={handleChangeNewPassword} />
                                        <label htmlFor="nova_senha" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Nova senha</label>

                                        <button onClick={toggleShowNewPassword} className="absolute right-0 mt-[8px] mr-[10px] justify-center text-slate-400 outline-none">
                                            <Icone icon={showNewPassword ? faEyeSlash : faEye} size="xl" />
                                        </button>
                                    </div>

                                    <div className="relative hidden col-span-12 mb-3">
                                        <input type={repeatePasswordInputType} id="repetir_nova_senha" className={`${classInput}  ${classInputDark} `} placeholder=" " value={repetirSenha} onChange={handleChangeRepeatePassword} />
                                        <label htmlFor="repetir_nova_senha" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Repetir nova senha</label>

                                        <button onClick={toggleShowRepeatePassword} className="absolute right-0 mt-[8px] mr-[10px] justify-center text-slate-400 outline-none">
                                            <Icone icon={showRepeatePassword ? faEyeSlash : faEye} size="xl" />
                                        </button>
                                    </div>
                                </div>
                                
                            </div>

                        </div>
                        { /* Card Body */}

                        <hr className="w-full border border-slate-200 dark:border-slate-700" />

                        { /* Card Footer */}
                        <div className="w-full h-[80px] flex justify-end items-center pr-2">

                            <button onClick={handleToggleLogo} className={`w-[200px] h-[40px] mr-2 ${classBt} ${classbtAzulEscuro}`}>
                                {!loading && <IoSave size="16px" className='mr-[10px]' />} {!loading ? "Salvar" : "Aguarde..."}

                            </button>

                            <FeedbackMessage visible={visible} message={message} type={messageType} onCloseMessage={handleCloseMessage} />
                        </div>
                        { /* Card Footer */}

                    </div>
                    { /* Card */}


                </div>
            </div>
        </Template>
    )


}